<div class="container-fluid">
  <h3 id="bondsman-main-area-header-label" class="row">Search for Bondsman/Surety</h3>
  <div class="row">
    <!-- 
    <div id="bondsman-search-criteria-div" class="col-xs-2">
    -->
    <div id="bondsman-search-criteria-div" [ngClass]="{'col-xs-2': isSearchDivOpen, 'closed': !isSearchDivOpen}">
      <form #bondmanSearchForm [formGroup]="bondsmanSearchFormGroup" autocomplete="off">
        <accordion [closeOthers]="true">
          <accordion-group [isOpen]="true" #suretyNameAccordionGroup>
            <div accordion-heading id="bondsman-search-criteria-overhead-search-by-other" tabindex="55" class="search-criteria-overhead"
              (click)="selectAccordion(enums.BondsmanAccordionType.Surety_Name, $event)">
              <i class="glyphicon pull-left" [ngClass]="{'glyphicon-triangle-bottom': suretyNameAccordionGroup?.isOpen, 'glyphicon-triangle-right': !suretyNameAccordionGroup?.isOpen}"></i>
              Bondsman/Surety Name
            </div>
            <div formGroupName="suretyNameSearchGroup">
              <div>
                <input id="bondsman-search-business-names" tabindex="190" type="checkbox" formControlName="searchBusinessNames" appFocusable>
                <span class="field-code">V477 </span>&nbsp;Search Business Names
              </div>
              <div class="btn-group pull-right">
                <span dropdown id="bondsman-search-name-match-type-dropdown">
                  <a href dropdownToggle tabindex="191" (click)="false" class="match-type-dropdown pull-right">
                    <span class="field-code">V482 </span>
                    {{bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchNameMatchType').value}}
                    <i class="glyphicon glyphicon-triangle-bottom"></i>
                  </a>
                  <ul *dropdownMenu class="dropdown-menu">
                    <li *ngFor="let choice of searchModes; let i=index;">
                      <a id="{{'bondsman-search-name-match-type-' + choice}}" tabindex="{{195 + i}}" class="dropdown-item" (click)="selectMatchType(choice)">{{choice}}</a>
                    </li>
                  </ul>
                </span>
                <br>
              </div>
              <div [class.search-item-hide]="bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchBusinessNames').value">
                <br>
                <div>
                  <label class="search-control-label">
                    <span class="field-code">V478.a </span>First Name</label>
                  <input id="bondsman-first-name-input" tabindex="210" type="text" class="form-control input-sm" formControlName="firstName">
                </div>
                <div>
                  <label class="search-control-label">
                    <span class="field-code">V478.b </span>Middle Name</label>
                  <input id="bondsman-middle-name-input" tabindex="230" type="text" class="form-control input-sm" formControlName="middleName">
                </div>
                <div [ngClass]="{'has-error': !bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').valid
                                 && ( submitted ) }">
                  <label class="search-control-label">
                    <span class="field-code">V478.c </span>Last Name (required)</label>
                  <input id="bondsman-last-name-input" tabindex="250" type="text" class="form-control input-sm" formControlName="lastName"
                    appFocusable>
                  <div class="control-label has-error" *ngIf="submitted && bondsmanSearchFormGroup.get('suretyNameSearchGroup.lastName').hasError('required')">
                    Last Name is required.
                  </div>
                </div>
                <br>
                <b>Or</b>
              </div>
              <!--<div [class.search-item-hide]="!bondsmanSearchFormGroup.get('suretyNameSearchGroup.searchBusinessNames').value">-->
              <div>
                <div [ngClass]="{'has-error': !bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').valid
                                  && ( submitted ) }">
                  <label class="search-control-label">
                      <span class="field-code">V484 </span>Business Name</label>
                  <input id="bondsman-business-name-input" tabindex="251" type="text" class="form-control input-sm" formControlName="businessName" appFocusable>
                  <div class="control-label has-error" *ngIf="submitted && bondsmanSearchFormGroup.get('suretyNameSearchGroup.businessName').hasError('required')">
                     Business Name is required.
                  </div>
                </div>
              </div>
            </div>
          </accordion-group>
          <accordion-group [isOpen]="false" #licenseNumberAccordionGroup>
            <div accordion-heading id="bondsman-search-criteria-overhead-search-by-license-number" tabindex="50" class="search-criteria-overhead"
              (click)="selectAccordion(enums.BondsmanAccordionType.License_Number, $event)">
              <i class="glyphicon pull-left" [ngClass]="{'glyphicon-triangle-bottom': licenseNumberAccordionGroup?.isOpen, 'glyphicon-triangle-right': !licenseNumberAccordionGroup?.isOpen}"></i>
              License Number
            </div>
            <div formGroupName="licenseNumberSearchGroup">
              <div [ngClass]="{'has-error': (!bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').valid)
                               && (submitted
                               ||  bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').touched 
                               ||  bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').dirty)}">
                <label class="search-control-label">
                  <span class="field-code">V650 </span>License Number</label>
                <input id="bondsman-search-number-input" tabindex="52" name="licenseNumber" type="text" class="form-control input-sm" formControlName="licenseNumber"
                  appFocusable>
                  <div class="control-label has-error" 
                     *ngIf="(submitted 
                            || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').touched 
                            || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').dirty)
                          && bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').hasError('required')">
                        License Number is required.
                  </div>
                  <div class="control-label has-error" 
                      *ngIf="(submitted 
                             || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').touched 
                             || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').dirty )
                          && ( bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').hasError('pattern')
                             || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').hasError('min')
                             || bondsmanSearchFormGroup.get('licenseNumberSearchGroup.licenseNumber').hasError('max'))">
                      Please enter a valid license number. Example: 0000123456.
                  </div>
              </div>
            </div>
          </accordion-group>
        </accordion>
        <div align="center">
          <button id="bondsman-search-btn" tabindex="400" class="btn btn-primary" (click)="onSearch()" popover="Please correct the highlighted errors."
            triggers="" placement="right" #searchpop="bs-popover" (mouseenter)="(!bondsmanSearchFormGroup.valid && submitted)? searchpop.show() : searchpop.hide();"
            (mouseleave)="searchpop.hide();">
            <i class="glyphicon glyphicon-search"></i> Search</button>
          <button id="bondsman-start-over-btn" tabindex="401" class="btn btn-primary" (click)="onStartOver()">Clear Form</button>
        </div>
      </form>
      <br>
      <div>
        <span>All information displayed on this site is subject to the disclaimer posted
          <a id="bondsman-disclaimer-view-lnk" tabindex="5000" (click)="openDisclaimer();">here</a>.</span>
      </div>
      <div *ngIf="!isProd()" class="show-field-code" [title]="showFieldCodeFlag ? 'Click to hide field code' : 'Click to show field code'"
        (click)="toggleFieldCodes()"> </div>
    </div>
    <!--
    <div id="bondsman-search-results-div" class="col-xs-10">
    -->
    <div id="bondsman-search-results-div" [ngClass]="{'col-xs-10': isSearchDivOpen, 'col-xs-12': !isSearchDivOpen}">
      <div id="bondsman-search-controls-outer-div" *ngIf="(getBondsmanSearchRecords() && !isLicenseNumberAccordionOpen())" (click)="toggleSearchCriteria()"
        [title]="isSearchDivOpen ? 'Close Search Criteria' : 'Open Search Criteria'">
        <div id="bondsman-search-controls-inner-div">
          <i id="bondsman-search-controls-arrow" class="fa fa-2x" [ngClass]="{'fa-chevron-circle-left': isSearchDivOpen, 'fa-chevron-circle-right': !isSearchDivOpen}"
            aria-hidden="true"></i>
        </div>
      </div>
      <div class="relative-position">
        <div *ngIf="searchCriteriaDescription" class="search-criteria-description-display">
          <span class="search-criteria-overhead-prefix">Search Results</span>
          <span>{{getTotalRecordsDescription()}} for</span>
          <span class="search-criteria-overhead-description"> {{searchCriteriaDescription}} </span>
          <br>
          <span class="search-record-last-updated-info">Note: The searched data was last updated from the system of record on {{searchRecordLastUpdateDate$ | async | date:'MM/dd/yyyy'}} at {{searchRecordLastUpdateDate$ | async | date:'shortTime'}}.</span>
        </div>
        <app-bondsman-search-results-table [Bondsman]="getBondsmanSearchRecords()" [errors]="errors" [requestIsInFlight]="isRequestInFlight()"></app-bondsman-search-results-table>
        <div *ngIf="doesBondsmanSearchHaveMoreRecords()">{{getDisplayedRecordsDescription()}}
          <a (click)="getNextBondsmanSearchRecords()">Get more results?</a>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/bondsman/bondsman.component.html